import React from 'react';
import { Box, Container, Grid, Typography, Divider, useTheme } from '@mui/material';

const Footer: React.FC = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.text.secondary,
        pt: 4,
        pb: 4,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={2} justifyContent="center" alignItems="center">
          <Grid item xs={12} textAlign="center">
            <Typography
              variant="h6"
              color="primary"
              gutterBottom
              sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              🍓 Strawberry Manual Tracker
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Empowering New Zealand's strawberry growers with data-driven insights for optimal crop management and yield optimization.
            </Typography>
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 3 }} />
        
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Typography variant="body2" color="text.secondary" align="center">
            © {currentYear} Strawberry Manual Tracker. iEcosystems All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
